import logo from './mainLogo.png';
import './App.css';
import { useNavigate } from 'react-router-dom';


const Header = ({ onBurgerClick, isMenuOpen }) => {
  const navigate = useNavigate();

  return (
    <div>
      <nav className="header-desktop">
        <img src={logo} className="logo-desktop" onClick={() => navigate('/')} alt="logo" />
        <ul className="nav-right">
          <li><a href="/dogwalkers" data-text="Dog Walkers">DogWalkers</a></li>
          <li><a href="/contact" data-text="Contact">Contact</a></li>
          <li><a href="/faq" data-text="Faq">FAQ</a></li>
        </ul>
      </nav>

      <div className="App-header">
        <img src={logo} className="logo-phone" onClick={() => navigate('/')} alt="logo" />
        {!isMenuOpen && (
          <button className="custom-burger-button" onClick={onBurgerClick}>☰</button>
        )}
      </div>
    </div>
  );
};

export default Header;